import styled from 'styled-components'

export const CalltoactionContainer = styled.div`
    background: #00b9ff;
    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/Pgo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDEgMSIgcHJlc2VydmVBc3BlY3RSYXRpbz0ibm9uZSI+CiAgPGxpbmVhckdyYWRpZW50IGlkPSJncmFkLXVjZ2ctZ2VuZXJhdGVkIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeDE9IjAlIiB5MT0iMCUiIHgyPSIwJSIgeTI9IjEwMCUiPgogICAgPHN0b3Agb2Zmc2V0PSIxMSUiIHN0b3AtY29sb3I9IiMwMGI5ZmYiIHN0b3Atb3BhY2l0eT0iMSIvPgogICAgPHN0b3Agb2Zmc2V0PSI5OSUiIHN0b3AtY29sb3I9IiMwMDdhZmYiIHN0b3Atb3BhY2l0eT0iMSIvPgogIDwvbGluZWFyR3JhZGllbnQ+CiAgPHJlY3QgeD0iMCIgeT0iMCIgd2lkdGg9IjEiIGhlaWdodD0iMSIgZmlsbD0idXJsKCNncmFkLXVjZ2ctZ2VuZXJhdGVkKSIgLz4KPC9zdmc+);
    background: -moz-linear-gradient(top,#7434b7 11%,#4caf50 99%);
    background: -webkit-gradient(linear,left top,left bottom,color-stop(11%,#00b9ff),color-stop(99%,#4caf50));
    background: -webkit-linear-gradient(top,#7434b7 11%,#4caf50 99%);
    background: -o-linear-gradient(top,#7434b7 11%,#4caf50 99%);
    background: -ms-linear-gradient(top,#7434b7 11%,#4caf50 99%);
    background: linear-gradient(to bottom,#7434b7 11%,#4caf50 99%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="$theme-gradient-end", endColorstr="$theme-gradient-start", GradientType=0 );
    background: url(/themes/defaultNiimko/images/evaluation-bg-optimize.png) no-repeat center center;
    background-size: cover;
    color: #fff;
    padding: 35px 0;
    text-align: center

    & h3 {
        color: #fff;
    }
    & .ui.button {
        margin-top: 1em;
    }
`